import React from 'react';
import {MemberDuplicates} from "../../../home/duplicates";

export function CommunityAdminDuplicates() {

    return <div>

            <MemberDuplicates />
    </div>
}